import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumber',
  standalone: true,
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    // Si c'est déjà au format international avec +
    if (value.startsWith('+')) {
      return this.formatInternationalNumber(value);
    }

    // Si c'est un numéro local, essayer de le formater
    return this.formatLocalNumber(value);
  }

  private formatInternationalNumber(phoneNumber: string): string {
    // Enlever le + pour le traitement
    const number = phoneNumber.substring(1);

    // Format pour les numéros sénégalais (+221)
    if (number.startsWith('221')) {
      const localNumber = number.substring(3);
      return `+221 ${localNumber.substring(0, 2)} ${localNumber.substring(
        2,
        5
      )} ${localNumber.substring(5, 7)} ${localNumber.substring(7)}`;
    }

    // Format pour les numéros français (+33)
    if (number.startsWith('33')) {
      const localNumber = number.substring(2);
      return `+33 ${localNumber.substring(0, 1)} ${localNumber.substring(
        1,
        3
      )} ${localNumber.substring(3, 5)} ${localNumber.substring(
        5,
        7
      )} ${localNumber.substring(7)}`;
    }

    // Format générique pour les autres pays
    if (number.length >= 10) {
      const countryCode = number.substring(0, 3);
      const rest = number.substring(3);
      return `+${countryCode} ${rest.substring(0, 3)} ${rest.substring(
        3,
        6
      )} ${rest.substring(6)}`;
    }

    // Si le format n'est pas reconnu, retourner tel quel
    return phoneNumber;
  }

  private formatLocalNumber(phoneNumber: string): string {
    // Nettoyer le numéro (enlever les espaces, tirets, etc.)
    const cleanNumber = phoneNumber.replace(/[\s\-\(\)]/g, '');

    // Format pour les numéros sénégalais (10 chiffres)
    if (cleanNumber.length === 10 && cleanNumber.startsWith('7')) {
      return `${cleanNumber.substring(0, 2)} ${cleanNumber.substring(
        2,
        5
      )} ${cleanNumber.substring(5, 7)} ${cleanNumber.substring(7)}`;
    }

    // Format pour les numéros français (10 chiffres)
    if (cleanNumber.length === 10 && cleanNumber.startsWith('0')) {
      return `${cleanNumber.substring(0, 1)} ${cleanNumber.substring(
        1,
        3
      )} ${cleanNumber.substring(3, 5)} ${cleanNumber.substring(
        5,
        7
      )} ${cleanNumber.substring(7)}`;
    }

    // Si le format n'est pas reconnu, retourner tel quel
    return phoneNumber;
  }
}
